import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./About.css";

import PageSection from "PageSection/PageSection";
import Section from "./Section/Section";
import Skills from "./Skills/Skills";
import Experience from "./Experience/Experience";
import Awards from "./Awards/Awards";
//import Hyperlink from "Hyperlink/Hyperlink";

import text from "text";
import {getAsset} from "utils";

export default class About extends Component
{
	render()
	{
		return (
			<PageSection handleRef={this.props.handleRef} className="about">
				<Section title="About Me">
					<p className="headerMargin" dangerouslySetInnerHTML={{__html: text.ABOUT}}></p>
					{/*<p className="headerMargin" dangerouslySetInnerHTML={{__html: text.ABOUT_CURRENT}}></p>*/}

					<p className="headerMargin">
						I currently study at the <strong>University of Washington</strong> and am pursuing a degree in Computer Science. I'm also a part
						of the <Link to="/cases/Robotics" className="underline"> <strong>Advanced Robotics</strong></Link> team which competes on an international stage during the summer battling other university's robots. My team
						works on creating a simulation of the game in <strong>Unity</strong> and I focus on <strong>networking</strong> which allows multiple people
						to play the simulation simultaneously.
					</p>

					<div className="husky-container">
						<img src={getAsset("icons/huskies.png")} alt="University of Washington" className="husky" />
					</div>
				</Section>

				<Section title="Skills">
					<Skills />
				</Section>

				<Section title="Experience">
					<Experience />
				</Section>

				<Section>
					<Awards />
				</Section>
			</PageSection>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/About.js